import * as Yup from 'yup';
import moment from 'moment';
import createCompanyFormModel from './createCompanyFormModel';
const {
  formField: {
    type_document,
    number_document,
    tradename,
    business_name,
    legal_representative,
    email,
    manager_in_charge,
    economic_activity,
    branch_offices,
    country,
    departament,
    municipaly,
    address_company,
    workplace,
    landline,
    cell_phone,

    // FORMA DE PAGO
    payment_frequency,
    payment_method,
    associated_bank,
    type_account_bank,
    account_number,

    // SEGURIDAD SOCIAL
    sgsst,
    arl,
    constitution_date,
    ley_1429_2010,
    ley_590_2000,
    ley_1607_2012,

    // ARCHIVOS
    rut,
    chamber_of_commerce,
    bank_certificate,

    // LOGOS NOMBRE COMERCIAL
    logo_bn_company,
    logo_bn_post_company,

    // LOGOS POST COMERCIAL
    logo_company,
    logo_post_company,
  },
} = createCompanyFormModel;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [type_document.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${type_document.requiredErrorMsg}`),

    [number_document.name]: Yup.string()
      .matches(
        /^[\d-]+$/, // Acepta cualquier combinación de dígitos y guiones
        'Solo se permiten números y guiones'
      )
      .typeError('Documento debe ser numerico')
      .label(`${number_document.typeDataMsg}`)
      .required(`${number_document.requiredErrorMsg}`),
    [tradename.name]: Yup.string().required(`${tradename.requiredErrorMsg}`),
    [business_name.name]: Yup.string().required(`${business_name.requiredErrorMsg}`),
    [legal_representative.name]: Yup.string().required(`${legal_representative.requiredErrorMsg}`),
    [email.name]: Yup.string()
      .required(`${email.requiredErrorMsg}`)
      .email(`${email.requiredErrorMsg}`),
    [manager_in_charge.name]: Yup.string().required(`${manager_in_charge.requiredErrorMsg}`),
    [economic_activity.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${economic_activity.requiredErrorMsg}`),
    [country.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${country.requiredErrorMsg}`),
    [departament.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${departament.requiredErrorMsg}`),
    [municipaly.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${municipaly.requiredErrorMsg}`),
    [address_company.name]: Yup.string().required(`${address_company.requiredErrorMsg}`),
    [workplace.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${workplace.requiredErrorMsg}`),
    [landline.name]: Yup.string().nullable(),
    [cell_phone.name]: Yup.string().required(`${tradename.requiredErrorMsg}`),
  }),

  // FORMA DE PAGO
  Yup.object().shape({
    [payment_frequency.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${payment_frequency.requiredErrorMsg}`),

    [payment_method.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${payment_method.requiredErrorMsg}`),

    [associated_bank.name]: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .default(undefined)
      .when([payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema
              .shape({
                value: Yup.string().required('Banco requerido'),
                label: Yup.string().required('Etiqueta requerida'),
              })
              .required(associated_bank.requiredErrorMsg);
      }),

    [type_account_bank.name]: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .default(undefined)
      .when([payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema
              .shape({
                value: Yup.string().required('Tipo cuenta requerida'),
                label: Yup.string().required('Etiqueta requerida'),
              })
              .required(`${type_account_bank.requiredErrorMsg}`);
      }),

    // [type_account_bank.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈
    // .required(`${type_account_bank.requiredErrorMsg}`),
    // [account_number.name]: Yup.string().required(`${account_number.requiredErrorMsg}`)

    [account_number.name]: Yup.string()
      .default(undefined)
      .when([payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema.required(`${type_account_bank.requiredErrorMsg}`);
      }),
  }),

  // SEGURIDAD SOCIAL
  Yup.object().shape({
    [sgsst.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${sgsst.requiredErrorMsg}`),
    [arl.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${arl.requiredErrorMsg}`),
    [constitution_date.name]: Yup.string().required(`${constitution_date.requiredErrorMsg}`),
    [ley_1429_2010.name]: Yup.boolean(),
    [ley_590_2000.name]: Yup.boolean(),
    [ley_1607_2012.name]: Yup.boolean(),
  }),

  // ARCHIVO
  Yup.object().shape({
    [rut.name]: Yup.string().required(`${rut.requiredErrorMsg}`),
    [chamber_of_commerce.name]: Yup.string().required(`${chamber_of_commerce.requiredErrorMsg}`),
    // [bank_certificate.name]: Yup.string().required(`${bank_certificate.requiredErrorMsg}`)
    [bank_certificate.name]: Yup.string()
      .default(undefined)
      .when([payment_method.name], ([paymentMethod], schema) => {
        return paymentMethod?.label.toLowerCase() === 'efectivo'
          ? schema.notRequired()
          : schema.required(`${bank_certificate.requiredErrorMsg}`);
      }),
  }),

  // LOGOS NOMBRE COMERCIAL
  Yup.object().shape({
    [logo_bn_company.name]: Yup.string().required(`${logo_bn_company.requiredErrorMsg}`),
    [logo_bn_post_company.name]: Yup.string().required(`${logo_bn_post_company.requiredErrorMsg}`),
  }),

  // LOGOS POST COMERCIAL
  Yup.object().shape({
    [logo_company.name]: Yup.string().required(`${logo_company.requiredErrorMsg}`),
    [logo_post_company.name]: Yup.string().required(`${logo_post_company.requiredErrorMsg}`),
  }),
];
